import React, { Component } from 'react';
import { Popup } from 'semantic-ui-react';

/**
 * Renders the provided children and uses them to trigger a tooltip with the specified content
 * @prop {node} children - The children will be rendered and used as the trigger for the tooltip.
 * @prop {string} [content] - the content to be displayed in the tooltip
 * @prop {number} [delay=750] - delay in MS to wait before opening the tooltip
 */

function HeaderInfoTooltip({ content, children }) {
  // If no content for thet tooltip, just render the children.
  if (!content) {
    return children;
  } else {
    return (
      <Popup
        position="top center"
        trigger={children}
        content={content}
        size="mini"
      />
    );
  }
}

export default HeaderInfoTooltip;
